import { render, staticRenderFns } from "./ShowClient.vue?vue&type=template&id=50035a25&scoped=true"
import script from "./ShowClient.vue?vue&type=script&lang=js"
export * from "./ShowClient.vue?vue&type=script&lang=js"
import style0 from "./ShowClient.vue?vue&type=style&index=0&id=50035a25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50035a25",
  null
  
)

/* custom blocks */
import block0 from "./ShowClient.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports